<template>
  <div>
    <div class="col-lg-2">
      <base-button
        style="font-size: 18px"
        @click="getBack()"
        class="btn-link btn-primary"
      >
        &lt; Back
      </base-button>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-12">
        <simple-wizard ref="tabs" :indextghrunning="huhuhaha" :totalstep="hoi">
          <template slot="header">
            <h2 class="card-title"></h2>
            <h3 class="description"></h3>
          </template>

          <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step1')"
          >
            <template slot="label">
              1
              <p style="color: #A5A5A5; width: 200px">Job Schedule</p>
            </template>
            <first-step
              v-if="firstflag"
              @my-event="myFunction"
              ref="step1"
              @on-validated="onStepValidated"
            ></first-step>
          </wizard-tab>

          <wizard-tab
            :activeTabIndex="activeTabIndex"
            :before-change="() => validateStep('step2')"
          >
            <template slot="label">
              2
              <p style="color: #A5A5A5; width: 200px">Job Information</p>
            </template>
            <second-step
              v-if="secondflag"
              @my-event="myFunction"
              ref="step2"
              @on-validated="onStepValidated"
            ></second-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step3')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              3
              <p style="color: #A5A5A5; width: 200px">Transporter Information</p>
            </template>
            <third-step
              v-if="thirdflag"
              @my-event="myFunction"
              ref="step3"
              @on-validated="onStepValidated"
            ></third-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step4')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              4
              <p style="color: #A5A5A5; width: 200px">eCAF</p>
            </template>
            <fourth-step
              v-if="fourthflag"
              @my-event="myFunction"
              ref="step4"
              @on-validated="onStepValidated"
            ></fourth-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step5')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              5
              <p style="color: #A5A5A5; width: 200px">Operation Photos</p>
            </template>
            <fifth-step
              v-if="fifthflag"
              @my-event="myFunction"
              ref="step5"
              @on-validated="onStepValidated"
            ></fifth-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step6')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              6
              <p style="color: #A5A5A5; width: 200px">PTW & Lab Report</p>
            </template>
            <sixth-step
              v-if="sixthflag"
              @my-event="myFunction"
              ref="step6"
              @on-validated="onStepValidated"
            ></sixth-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step7')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              7
              <p style="color: #A5A5A5; width: 200px">Weight Bridge & CN</p>
            </template>
            <seven-step
              v-if="seventhflag"
              @my-event="myFunction"
              ref="step7"
              @on-validated="onStepValidated"
            ></seven-step>
          </wizard-tab>

          <wizard-tab
            :before-change="() => validateStep('step8')"
            :activeTabIndex="activeTabIndex"
          >
            <template slot="label">
              8
              <p style="color: #A5A5A5; width: 200px">Review</p>
            </template>
            <eight-step
              v-if="eightflag"
              @my-event="myFunction"
              ref="step8"
              @on-validated="onStepValidated"
            ></eight-step>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from "../../Admin/Outgoing/OutgoingJobPage/JobSchedule.vue";
import SecondStep from "../../Admin/Outgoing/OutgoingJobPage/JobInformation.vue";
import ThirdStep from "../../Admin/Outgoing/OutgoingJobPage/TransporterInformation.vue";
import FourthStep from "../../Admin/Outgoing/OutgoingJobPage/Ekaf.vue";
import FifthStep from "../../Admin/Outgoing/OutgoingJobPage/JobPhotos.vue";
import SixthStep from "../../Admin/Outgoing/OutgoingJobPage/PTW.vue";
import SevenStep from "../../Admin/Outgoing/OutgoingJobPage/CN.vue";
import EightStep from "../../Admin/Outgoing/OutgoingJobPage/Review.vue";

import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "src/components";

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    FifthStep,
    SixthStep,
    SevenStep,
    SevenStep,
    EightStep,
    SimpleWizard,
    WizardTab,
  },
  data() {
    return {
      firstflag: true,
      secondflag: false,
      thirdflag: false,
      fourthflag: false,
      fifthflag: false,
      sixthflag: false,
      seventhflag: false,
      eightflag: false,
      wizardModel: {},
      activeTabIndex: 0,
      jobstatus: "",
      landvesselflag: "VESSEL",
      huhuhaha: "",
      hoi: 0,
      renderComponent: false,
      componentKey: 0,
    };
  },

  created() {
    // this.huhuhaha = 1
    // this.getDetail(this.$route.params.jobnum.split("_")[0]);
  },
  methods: {
    // forceRerender() {
    //   this.componentKey += 1;
    //   console.log("rerender: ", this.componentKey);
    //   this.getDetail(this.$route.params.jobnum.split("_")[0]);
    // },
    // getDetail(refNo) {
    //   this.$http.get(":10001/api/v1/incoming/garbage/" + refNo).then((res) => {
    //     if (!res.error) {
    //       let response = res.message;
    //       console.log(response);
    //       // this.landvesselflag = response.company.company_type.toUpperCase();
    //       // this.huhuhaha = response.dashboard_step;
    //       // this.hoi = 5;
    //     }
    //   });
    // },
    myFunction(e) {
      // this.firstflag = false
      this.secondflag = false;
      this.thirdflag = false;
      this.fourthflag = false;
      this.fifthflag = false;
      this.sixthflag = false;
      this.seventhflag = false;
      this.eightflag = false;
      this.flag = false;
      let index = parseInt(e.step);

      this.hoi = 8;

      if (e.direction == "depan") {
        if (e.step == "0") {
          this.firstflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = false;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = false;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = false;
            this.$refs.tabs.tabs[this.hoi - 8].active = true;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;

            this.huhuhaha = 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }
        if (e.step == "1") {
          this.secondflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = false;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = false;
            this.$refs.tabs.tabs[this.hoi - 7].active = true;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;

            this.huhuhaha = 2;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );

          this.$emit("update:startIndex", index);
        }

        if (e.step == "2") {
          this.thirdflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = false;
            this.$refs.tabs.tabs[this.hoi - 6].active = true;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;
            this.huhuhaha = 3;
            // this.huhuhaha = parseInt(e.step);
          }, 100);

          console.log(this.$refs.tabs);
          console.log(this.thirdflag);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          // let newValue = index + 1;
          this.$emit("update:startIndex", index);
        }

        if (e.step == "3") {
          this.fourthflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = true;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;
            this.huhuhaha = 4;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          this.$emit("update:startIndex", index);
        }

        if (e.step == "4") {
          this.fifthflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = true;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;
            this.huhuhaha = 5;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          this.$emit("update:startIndex", index);
        }

        if (e.step == "5") {
          this.sixthflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = true;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;
            this.huhuhaha = 6;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          this.$emit("update:startIndex", index);
        }

        if (e.step == "6") {
          this.seventhflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = true;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;
            this.huhuhaha = 7;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          this.$emit("update:startIndex", index);
        }

        if (e.step == "7") {
          this.eightflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = true;
            this.$refs.tabs.tabs[this.hoi - 1].checked = true;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;
            this.huhuhaha = 8;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          this.$emit("update:startIndex", index);
        }
      }

      if (e.direction == "blkg") {
        if (e.step == "1") {
          this.getBack();
        }

        if (e.step == "2") {
          this.firstflag = true;
          this.$refs.tabs.tabs[this.hoi - 1].active = false;
          this.$refs.tabs.tabs[this.hoi - 1].checked = false;
          this.$refs.tabs.tabs[this.hoi - 2].active = false;
          this.$refs.tabs.tabs[this.hoi - 2].checked = false;
          this.$refs.tabs.tabs[this.hoi - 3].active = false;
          this.$refs.tabs.tabs[this.hoi - 3].checked = false;
          this.$refs.tabs.tabs[this.hoi - 4].active = false;
          this.$refs.tabs.tabs[this.hoi - 4].checked = false;
          this.$refs.tabs.tabs[this.hoi - 5].active = false;
          this.$refs.tabs.tabs[this.hoi - 5].checked = false;
          this.$refs.tabs.tabs[this.hoi - 6].active = false;
          this.$refs.tabs.tabs[this.hoi - 6].checked = false;
          this.$refs.tabs.tabs[this.hoi - 7].active = false;
          this.$refs.tabs.tabs[this.hoi - 7].checked = false;
          this.$refs.tabs.tabs[this.hoi - 8].active = true;
          this.$refs.tabs.tabs[this.hoi - 8].checked = true;

          this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "3") {
          this.secondflag = true;
          this.$refs.tabs.tabs[this.hoi - 1].active = false;
          this.$refs.tabs.tabs[this.hoi - 1].checked = false;
          this.$refs.tabs.tabs[this.hoi - 2].active = false;
          this.$refs.tabs.tabs[this.hoi - 2].checked = false;
          this.$refs.tabs.tabs[this.hoi - 3].active = false;
          this.$refs.tabs.tabs[this.hoi - 3].checked = false;
          this.$refs.tabs.tabs[this.hoi - 4].active = false;
          this.$refs.tabs.tabs[this.hoi - 4].checked = false;
          this.$refs.tabs.tabs[this.hoi - 5].active = false;
          this.$refs.tabs.tabs[this.hoi - 5].checked = false;
          this.$refs.tabs.tabs[this.hoi - 6].active = false;
          this.$refs.tabs.tabs[this.hoi - 6].checked = false;
          this.$refs.tabs.tabs[this.hoi - 7].active = true;
          this.$refs.tabs.tabs[this.hoi - 7].checked = true;
          this.$refs.tabs.tabs[this.hoi - 8].active = false;
          this.$refs.tabs.tabs[this.hoi - 8].checked = true;
          this.huhuhaha = parseInt(e.step) - 1;

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "4") {
          this.thirdflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = false;
            this.$refs.tabs.tabs[this.hoi - 6].active = true;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;

            this.huhuhaha = parseInt(e.step) - 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "5") {
          this.fourthflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = false;
            this.$refs.tabs.tabs[this.hoi - 5].active = true;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;

            this.huhuhaha = parseInt(e.step) - 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "6") {
          this.fifthflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = false;
            this.$refs.tabs.tabs[this.hoi - 4].active = true;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;

            this.huhuhaha = 5;
          }, 100);

          console.log(this.$refs.tabs);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "7") {
          this.sixthflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = false;
            this.$refs.tabs.tabs[this.hoi - 2].checked = false;
            this.$refs.tabs.tabs[this.hoi - 3].active = true;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;

            this.huhuhaha = parseInt(e.step) - 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }

        if (e.step == "8") {
          this.seventhflag = true;
          setTimeout(() => {
            this.$refs.tabs.tabs[this.hoi - 1].active = false;
            this.$refs.tabs.tabs[this.hoi - 1].checked = false;
            this.$refs.tabs.tabs[this.hoi - 2].active = true;
            this.$refs.tabs.tabs[this.hoi - 2].checked = true;
            this.$refs.tabs.tabs[this.hoi - 3].active = false;
            this.$refs.tabs.tabs[this.hoi - 3].checked = true;
            this.$refs.tabs.tabs[this.hoi - 4].active = false;
            this.$refs.tabs.tabs[this.hoi - 4].checked = true;
            this.$refs.tabs.tabs[this.hoi - 5].active = false;
            this.$refs.tabs.tabs[this.hoi - 5].checked = true;
            this.$refs.tabs.tabs[this.hoi - 6].active = false;
            this.$refs.tabs.tabs[this.hoi - 6].checked = true;
            this.$refs.tabs.tabs[this.hoi - 7].active = false;
            this.$refs.tabs.tabs[this.hoi - 7].checked = true;
            this.$refs.tabs.tabs[this.hoi - 8].active = false;
            this.$refs.tabs.tabs[this.hoi - 8].checked = true;

            this.huhuhaha = parseInt(e.step) - 1;
          }, 100);

          this.$emit(
            "tab-change",
            this.$refs.tabs.tabs[index - 1],
            this.$refs.tabs.tabs[index]
          );
          let newValue = index + 1;
          this.$emit("update:startIndex", newValue);
        }
      }
    },
    getBack() {
      this.$router.push("/Outgoing");
    },
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    async validate(tab) {
      let tabToValidate = tab || this.activeTab;

      let beforeChange = tabToValidate.beforeChange;
      if (beforeChange) {
        return Promise.resolve(beforeChange())
          .then((res) => {
            this.activeTab.hasError = res ? false : true;
            return res;
          })
          .catch(() => {
            this.activeTab.hasError = true;
          });
      } else {
        return Promise.resolve(true);
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      swal("Good job!", "You clicked the finish button!", "success");
    },
  },
};
</script>
